import {FlexFixed, FlexGrow, FlexRow} from "../Flex";
import AioSelect from "./AioSelect";
import type {ChangeEventHandler} from "react";
import React from "react";
import AioPhoneOnly from './AioPhoneOnly'
import type {SelectOptions} from '../../helpers/react-helpers'


interface Props {
    numberValue: string
    typeValue: string
    loading?: boolean
    disabled?: boolean
    numberOnChange: CompatEventHandler
    typeOnChange: ChangeEventHandler<HTMLSelectElement>
    label: string
    typeOptions: Readonly<SelectOptions>
    testId?: string
}


export default function AioPhoneNumber(props: Props) {
    return (
        <FlexRow gap={5}>
            <FlexGrow>
                <AioPhoneOnly label={props.label} value={props.numberValue} disabled={props.disabled}
                         loading={props.loading} onChange={props.numberOnChange} testId={props.testId ? `${props.testId}-number` : undefined}/>
            </FlexGrow>
            <FlexFixed width={95}>
                <AioSelect label="Type" value={props.typeValue} disabled={props.disabled} loading={props.loading}
                           onChange={props.typeOnChange} options={props.typeOptions} testId={props.testId ? `${props.testId}-type` : undefined}/>
            </FlexFixed>
        </FlexRow>
    )
}
